import { useEffect } from "react";
import { X } from "lucide-react";
import { fmtChips } from "../../lib/api";
import { AssetImage } from "../AssetImage";
import { sounds } from "../../lib/sounds";

// Shown once, the first time a brand-new player lands in the lobby: what they were given, and the promo on top of it.
export const WelcomeModal = ({ welcome, onClose }) => {
  useEffect(() => { sounds.chipsBet?.(); }, []);
  const promo = welcome.promo_chips > 0;
  return (
    <div data-testid="welcome-modal" className="fixed inset-0 z-[80] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose}>
      <div className="gold-card noise rounded-3xl w-full max-w-xl text-slate-100 rise overflow-hidden" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between px-6 pt-5">
          <div>
            <div className="text-[10px] uppercase tracking-[0.5em] text-amber-300/80">Players Room</div>
            <div className="font-display text-2xl md:text-3xl text-amber-100 tracking-wide">WELCOME TO THE TABLE</div>
          </div>
          <button data-testid="welcome-close" onClick={onClose} className="rounded-full p-1.5 hover:bg-white/10"><X className="w-5 h-5" /></button>
        </div>

        <div className="flex flex-col items-center gap-4 px-6 pt-4">
          <AssetImage id="logo_emblem" width={128} className="w-32 h-32 drop-shadow-[0_0_40px_rgba(251,191,36,0.35)]" />
          <div className="w-full flex flex-col gap-2">
            <div className="flex items-center gap-3 rounded-xl border border-white/10 bg-black/30 px-4 py-3" data-testid="welcome-signup-chips">
              <AssetImage id="chip_1000" width={34} className="w-9 h-9" />
              <span className="text-sm text-slate-300 flex-1">Starting chips</span>
              <span className="font-mono text-amber-100">{fmtChips(welcome.signup_chips)}</span>
            </div>
            {promo && (
              <div className="flex items-center gap-3 rounded-xl border border-amber-400/50 bg-amber-400/10 px-4 py-3" data-testid="welcome-promo-chips">
                <AssetImage id="chip_5k" width={34} className="w-9 h-9" />
                <span className="text-sm text-amber-100 flex-1">{welcome.promo_name || "Launch bonus"} <span className="text-[11px] text-amber-300/80">· promo chips</span></span>
                <span className="font-mono text-amber-200">+{fmtChips(welcome.promo_chips)}</span>
              </div>
            )}
            <div className="flex items-center gap-3 rounded-xl border border-amber-400/70 bg-amber-500/15 px-4 py-3" data-testid="welcome-total">
              <span className="font-display text-sm tracking-[0.2em] text-amber-200 flex-1">IN YOUR WALLET</span>
              <span className="font-mono text-xl text-amber-100">{fmtChips(welcome.total)}</span>
            </div>
          </div>
          <p className="text-xs text-slate-400 text-center">
            Every shuffle here is committed to before a card is dealt, and you can check it yourself after any hand.
            Chips are for entertainment only and are not redeemable. 18+.
          </p>
        </div>

        <div className="flex items-center justify-center px-6 py-6">
          <button data-testid="welcome-play" onClick={onClose}
            className="rounded-full px-8 py-3 font-display text-sm bg-amber-500 hover:bg-amber-400 text-slate-900 btn-lift tracking-wider">
            LET'S PLAY
          </button>
        </div>
      </div>
    </div>
  );
};
